<template>
  <div class="vertical-align-wrap">
    <div class="vertical-align-middle">
      <div class="auth-box ">
        <div class="left">
          <div class="content">
            <div class="logo text-center"><img src="../assets/img/logo.png" alt="VDCI Logo"></div>
            <form class="form-auth-small" @submit.prevent="onSubmit">
              <div class="form-group">
                <label for="signup-email" class="control-label sr-only">Email</label>
                <input type="email" class="form-control" id="signup-email" v-model="user.email" placeholder="Email"
                  required autofocus>
              </div>
              <div class="form-group">
                <label for="signup-password" class="control-label sr-only">Password</label>
                <input type="password" class="form-control" id="signup-password" v-model="user.password"
                  placeholder="Password" required>
              </div>

              <loading-button :loading="loading" class="btn btn-primary btn-lg btn-block">LOGIN</loading-button>
              <div class="bottom">
                <span><i class="fa fa-lock"></i> <router-link :to="{ name: 'forgot-password' }">Forgot
                    password?</router-link></span>
              </div>
            </form>
          </div>
        </div>
        <div class="right">
          <div class="overlay"></div>
          <div class="content text">
            <h1 class="heading">Vector Disease Control International</h1>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService';
import LoadingButton from '@/components/loading-button';

export default {
  name: 'login',

  components: {
    LoadingButton
  },

  data() {
    return {
      loading: false,
      user: {
        email: '',
        password: ''
      }
    }
  },

  methods: {
    onSubmit() {
      this.loading = true;
      AuthService.login(this.user)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: 'spray-paths' });
        })
        .catch((error) => {
          this.loading = false;
          toastr.error('Sorry, we cannot find your account. Please check your email/password.');
        })
    }
  }
}
</script>

<style lang="scss"></style>
